import React from 'react';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/pro-duotone-svg-icons';
import Axios from 'axios';
import FileSaver from 'file-saver';
import { LogToBackend } from '../../configs/helpers/LogToBackend';
import { useSnackbar } from 'notistack';

function Manual(props) {
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const getManual = () => {
      Axios.get(`/GSB/dashboard/file/DownloadTemplate?fileType=7`, {
         responseType: 'blob',
      })
         .then((response) => {
            if (response) {
               FileSaver.saveAs(new Blob([response.data]), 'user_manual.pdf');
            }
         })
         .catch((err) => {
            LogToBackend(err);
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };
   return (
      <Button
         startIcon={<FontAwesomeIcon icon={faFileDownload} size={'xs'} />}
         variant={'contained'}
         color={'primary'}
         onClick={getManual}
      >
         ดาวน์โหลดคู่มือการใช้งาน
      </Button>
   );
}

export default Manual;
